/* RESPONSIBLE TEAM: team-workflows */
import ConditionalBranchesConfiguration from './conditional-branches';
import { type StepConfigParams } from '../step';
import type ConnectionPoint from 'embercom/models/operator/visual-builder/connection-point';
import type EscalationRuleTriggered from 'embercom/models/operator/visual-builder/step/escalation-rule-triggered';

export default class EscalationRuleTriggeredConfiguration extends ConditionalBranchesConfiguration {
  declare step: EscalationRuleTriggered;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/escalation-rule-triggered',
      ...params,
    } as StepConfigParams);
  }

  deleteBranch(branch: ConnectionPoint) {
    this.intercomEventService.trackAnalyticsEvent({ object: branch, action: 'removed' });
    this.branches.removeObject(branch);
    this.editorState.logInteraction('Deleted escalation branch');
  }
}
